import {
    SET_TERMINAL_AUTH_DATA, SET_TERMINAL_BALANCE, CHANGE_SPORTSBOOK_LAYOUT, SET_POPUP_LAUNCHER,
    SHOW_KEYBOARD, SET_DEPOSIT_BALANCE, REMOVE_DEPOSIT_BALANCE, HIDE_BETSLIP,
    SET_TERMINAL_ACUMULATOR_BONUSE, SET_STARTUP_SETTINGS, SHOW_LAST_BETS_LIST, CLEAR_LAST_BETS_LIST, IS_ADMIN_LOGGED_IN, IS_CARD_REGISTERED, CLEAR_CARD_REGISTERED, LOYAL_CARD, GET_BOOSTED_ODDS, SET_LOYAL_CARD_INPUT_ACTIVE
} from "../actions/actionTypes";
const initStore = {
    startupSettings: {
        MinBet: 0,
        MaxBet: Infinity,
        MinimalOdd: 0,
        HideLogo: false,
    },
    showLastBetsList: [],
    isCardRegistered: {},
    boostedOddsGameIds: {},
    isLoyalCardInputActive: false
};
const reducerTerminal = (state = initStore, action) => {
    switch (action.type) {
        case SET_TERMINAL_AUTH_DATA:
            return {
                ...state,
                ...action.payload
            };
        case SET_LOYAL_CARD_INPUT_ACTIVE:
            return {
                ...state,
                isLoyalCardInputActive: action.isActive
            }
        case SET_TERMINAL_BALANCE:
            return {
                ...state,
                balance: {
                    ...action.payload
                }
            };
        case LOYAL_CARD:
            return {
                ...state,
                loyalCard: {
                    ...action.payload
                }
            };
        case SET_STARTUP_SETTINGS: {
            return {
                ...state,
                startupSettings: {
                    ...action.payload
                }
            };
        }
        case GET_BOOSTED_ODDS: {
            return {
                ...state,
                boostedOddsGameIds: {
                    ...action.payload
                }
            };
        }
        case SET_TERMINAL_ACUMULATOR_BONUSE: {
            return {
                ...state,
                bonuses: action.payload
            };
        }
        case CHANGE_SPORTSBOOK_LAYOUT:
            return {
                ...state,
                isAsian: action.payload
            };
        case IS_ADMIN_LOGGED_IN:
            return {
                ...state,
                isAdminLoggedIn: action.payload
            };
        case IS_CARD_REGISTERED:
            console.log({...state},"========card state")
            return {
                ...state,
                isCardRegistered: action.payload
            };
        case CLEAR_CARD_REGISTERED:
            return {
                ...state,
                isCardRegistered: {}
            };
        case SHOW_KEYBOARD:
            return {
                ...state,
                showKeyboard: action.payload
            };
        case HIDE_BETSLIP:
            return {
                ...state,
                hideBetslip: action.payload
            };
        case SHOW_LAST_BETS_LIST:
            return {
                ...state,
                showLastBetsList: action.payload
            };
        case CLEAR_LAST_BETS_LIST:
            return {
                ...state,
                showLastBetsList: []
            };
        case SET_POPUP_LAUNCHER:
            return {
                ...state,
                popupLauncher: action.payload
            };
        case SET_DEPOSIT_BALANCE:
            return {
                ...state,
                balance: action.payload
            };
        case REMOVE_DEPOSIT_BALANCE:
            delete state.balance;
            return {
                ...state
            };
        default:
            return state;
    }
};

export default reducerTerminal;